import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, MailIcon } from 'lucide-react';
export function HeroSection() {
  const handleScrollToPrice = () => {
    const el = document.getElementById('precio-final');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full px-5 pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-150">
      <div className="max-w-3xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-152">
          {/* Badge */}
          <span className="inline-block px-4 py-1.5 text-xs font-medium tracking-wide uppercase rounded-full border border-[#B8A99A]/40 text-[#B8A99A] mb-8" data-id="element-153">
            Producto digital · Descarga inmediata
          </span>

          {/* H1 */}
          <h1 className="text-3xl md:text-[2.75rem] md:leading-[1.2] font-semibold text-[#2C2825] mb-6 leading-tight" data-id="element-154">
            ¿Y si pudieras saber exactamente por qué tienes ojeras… y qué hacer
            en los próximos 7 días?
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg text-[#2C2825]/75 mb-10 leading-relaxed max-w-2xl" data-id="element-155">
            <strong className="font-semibold text-[#2C2825]" data-id="element-156">
              Mapa de Ojeras™
            </strong>{' '}
            es el primer sistema visual que te ayuda a identificar tu tipo de
            ojera y aplicar una rutina personalizada de 7 días — sin adivinar,
            sin productos caros que no funcionan.
          </p>

          {/* Bullets */}
          <ul className="space-y-4 mb-10" data-id="element-157">
            <li className="flex items-start gap-3" data-id="element-158">
              <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-[#C4956A]/15 flex items-center justify-center" data-id="element-159">
                <CheckIcon className="w-3 h-3 text-[#C4956A]" data-id="element-160" />
              </span>
              <span className="text-[#2C2825]/80 text-[15px]" data-id="element-161">
                Test visual de 3 minutos para identificar tu tipo de ojera
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-162">
              <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-[#C4956A]/15 flex items-center justify-center" data-id="element-163">
                <CheckIcon className="w-3 h-3 text-[#C4956A]" data-id="element-164" />
              </span>
              <span className="text-[#2C2825]/80 text-[15px]" data-id="element-165">
                Rutina 2+1 personalizada según tu resultado
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-166">
              <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-[#C4956A]/15 flex items-center justify-center" data-id="element-167">
                <CheckIcon className="w-3 h-3 text-[#C4956A]" data-id="element-168" />
              </span>
              <span className="text-[#2C2825]/80 text-[15px]" data-id="element-169">
                Guía de corrección óptica para verte descansada hoy mismo
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-170">
              <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-[#C4956A]/15 flex items-center justify-center" data-id="element-171">
                <CheckIcon className="w-3 h-3 text-[#C4956A]" data-id="element-172" />
              </span>
              <span className="text-[#2C2825]/80 text-[15px]" data-id="element-173">
                Tracker de 7 días para ver tu progreso real
              </span>
            </li>
          </ul>

          {/* CTA #1 */}
          <button onClick={handleScrollToPrice} className="w-full sm:w-auto px-8 py-4 bg-[#C4956A] hover:bg-[#A87B54] text-white font-semibold text-base rounded-xl transition-colors duration-200 shadow-lg shadow-[#C4956A]/20" data-id="element-174">
            Quiero mi Mapa de Ojeras™
          </button>

          {/* Microcopy */}
          <p className="mt-4 flex items-center gap-2 text-sm text-[#2C2825]/50" data-id="element-175">
            <MailIcon className="w-4 h-4" data-id="element-176" />
            Recibes todo por email en menos de 5 minutos
          </p>
        </motion.div>

        {/* Hero Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mt-12 md:mt-16" data-id="element-177">
          <img src="https://cdn.magicpatterns.com/uploads/wMtUtDLLEaX7f6rWYhHMiB/mockup-ojeras1.png" alt="Mujer mirándose las ojeras en el espejo junto a un iPad con la portada del ebook Mapa de Ojeras" className="w-full rounded-2xl shadow-xl shadow-[#2C2825]/8" data-id="element-178" />
        </motion.div>
      </div>
    </section>;
}